import { render, staticRenderFns } from "./SosvProductTree.vue?vue&type=template&id=6ce1a590&"
import script from "./SosvProductTree.vue?vue&type=script&lang=js&"
export * from "./SosvProductTree.vue?vue&type=script&lang=js&"
import style0 from "./SosvProductTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports